<template>
  <div id="app">
    <StatsComp
      v-if="stats"
      :stats="stats"
      :averageTimeAndon15Days="averageTimeAndon15Days"
      :averageTimeAndon30Days="averageTimeAndon30Days"
      :selected="bus.currentStep"
    />

    <!-- <b-jumbotron header="Andon Kanban" lead="Andon généré par les cartes kanban" >
      <p>Moyenne temps d'arret andon : <b-badge>{{ averageTimeAndon }} min</b-badge><br>
          <span v-if="stats">
            Cartes scannées aujourd'hui: <b-badge>{{ stats.nbr_scanned }}</b-badge><br>
            Andon créés aujourd'hui : <b-badge>{{ stats.andon_created }}</b-badge><br>
            Andon stoppés aujourd'hui : <b-badge>{{ stats.andon_stopped }}</b-badge>
          </span>
        </p>
      <p v-if="lastScan.length > 0" >
        Dernier scan:
        <b-badge>
          {{ lastScan[0].kanban_card.kanban_reference.reference.code }}
          <small>({{ lastScan[0].kanban_card.card_id }})</small>
        </b-badge>

      il y a <b-badge>{{ (timeAndon(lastScan[0].created_at)) }} min </b-badge>
        <b-badge>{{displayStep(lastScan[0].workstation.name)}}</b-badge>
      </p>
    </b-jumbotron>-->
    <!-- @blur="closeMenu" -->
    <div>
      <b-form-group label="Andon activé">
        <b-form-checkbox-group
          v-model="andonTypeSelected"
          @change="changeSelectedType"
          :options="andonType"
          switches
        ></b-form-checkbox-group>
        <div  class="input-align">
          <b>1</b>
          <b-form-input
            id="input-1"
            class="input-andon-nbr"
            @change="refreshTable"
            v-model="nbrAndons"
            type="range"
            min="1" max="10"
            label="coucou"
          ></b-form-input>
          <b>10</b>
          <label class="label-input" for="input-1"> &nbsp {{nbrAndons}}  Nbr de cartes max</label>
        </div>
      </b-form-group>
    </div>
    <table width="100%" v-if="grid" id="andontable" ref="appdiv">
      <thead>
        <tr class="grey">
          <td v-for="index in grid[0].length" v-bind:key="index" >
            <span v-if="index <= 10 && index > 1">0{{ index - 1 }}</span>
            <span v-else-if="index > 1">{{ index - 1 }}</span>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, indexRow) in grid" v-bind:key="indexRow">
          <td class="grey">S{{ alphabet[indexRow] }}</td>
          <td v-for="(col, indexCol) in row" v-bind:key="indexCol" v-if="indexCol!==0">
            <div v-if="isGridListPrintable(lowStockGrid[indexRow][indexCol], 'low_stock')">
              <div
                v-for="(item, index) in lowStockGrid[indexRow][indexCol]"
                v-bind:key="item.andon.base_id"
                v-b-popover.hover.top="item.andon.kanban_reference.reference.designation"
                style="background-color: rgb(245, 245, 245); margin:5px;"
                :ref="item.andon.base_id"
              >
                <!--                 <div v-if="displayHighSeverityAndon()">
                  <low-stock-card v-if="item.andon.base.severity == 'high'" :item="item"/>
                </div>
                <div v-else>-->
                <low-stock-card
                  @andon-stopped="hideAndon(index, lowStockGrid, indexRow, indexCol)"
                  :item="item"
                />
                <!-- </div> -->
              </div>
            </div>

            <div v-if="isGridListPrintable(unseenGrid[indexRow][indexCol], 'unseen_card')">
              <div
                v-for="(item, index) in unseenGrid[indexRow][indexCol]"
                v-bind:key="item.andon.base_id"
                v-b-popover.hover.top="item.andon.kanban_card.kanban_reference.reference.designation"
                style="background-color: rgb(245, 245, 245); margin:5px;"
              >
                <!-- <div v-if="displayHighSeverityAndon()">
                  <unseen-card  v-if="item.andon.base.severity == 'high'" :item="item"/>
                </div>
                <div v-else>-->
                <unseen-card
                  @andon-stopped="hideAndon(index, unseenGrid, indexRow, indexCol)"
                  :item="item"
                />
                <!-- </div> -->
              </div>
            </div>

            <div v-if="isGridListPrintable(fifoGrid[indexRow][indexCol], 'fifo')">
              <div
                v-for="(item, index) in fifoGrid[indexRow][indexCol]"
                v-bind:key="item.andon.base_id"
                style="background-color: rgb(245, 245, 245); margin:5px;"
                v-b-popover.hover.top="item.andon.andon_scan.kanban_card.kanban_reference.reference.designation"
                title="Info"
                :ref="item.andon.base_id"
              >
                <!-- <div v-if="displayHighSeverityAndon()">
                  <fifo-card  v-if="item.andon.base.severity == 'high'" :item="item"/>
                </div>
                <div v-else>-->
                <fifo-card
                  @andon-stopped="hideAndon(index, fifoGrid, indexRow, indexCol)"
                  :item="item"
                />
                <!-- </div> -->
              </div>
            </div>
            <div v-if="isGridListPrintable(erpStockGrid[indexRow][indexCol], 'bad_erp_stock')">
              <div
                v-for="(item, index) in erpStockGrid[indexRow][indexCol]"
                v-bind:key="item.andon.base_id"
                style="background-color: rgb(245, 245, 245); margin:5px;"
                v-b-popover.hover.top="item.andon.designation"
                title="Info"
                :ref="item.andon.base_id"
              >
                <!-- <div v-if="displayHighSeverityAndon()">
                  <fifo-card  v-if="item.andon.base.severity == 'high'" :item="item"/>
                </div>
                <div v-else>-->
                <bad-erp-stock-card
                  @andon-stopped="hideAndon(index, erpStockGrid, indexRow, indexCol)"
                  :item="item"
                />
                <!-- </div> -->
              </div>
            </div>
            <div v-if="isGridListPrintable(tempGrid[indexRow][indexCol], 'temp_card')">
              <div
                v-for="(item, index) in tempGrid[indexRow][indexCol]"
                v-bind:key="item.card_id"
                style="background-color: rgb(245, 245, 245); margin:5px;"
                v-b-popover.hover.top="item.kanban_reference.reference.designation"
                title="Info"
                :ref="item.card_id"
              >
                <!-- <div v-if="displayHighSeverityAndon()">
                  <fifo-card  v-if="item.andon.base.severity == 'high'" :item="item"/>
                </div>
                <div v-else>-->
                <temp-card
                  @andon-stopped="hideAndon(index, tempGrid, indexRow, indexCol)"
                  :item="item"
                />
                <!-- </div> -->
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import server from '../../api/server.vue'
import { Steps } from '../../core/services/steps.js'
import { bus } from '../../core/utils/bus.js'
import FifoCard from './FifoCard.vue'
import TempCard from './TempCard.vue'
import LowStockCard from './LowStockCard.vue'
import UnseenCard from './UnseenCard.vue'
import BadErpStockCard from './BadErpStockCard.vue'
import StatsComp from './stats'

export default {
  name: 'AndonKanban',
  props: ['step', 'title'],
  data() {
    return {
      bus: bus,
      selectedItem: '',
      nbrAndons: 3,
      grid: null,
      severityAndonGrid: null,
      fifoGrid: null,
      lowStockGrid: null,
      unseenGrid: null,
      erpStockGrid: null,
      tempGrid: null,
      lastScan: [],
      gridTimer: null,
      isBusy: false,
      andonType: [],
      andonTypeSelected: [],
      stepList: Steps,
      viewMenu: false,
      top: '0px',
      left: '0px',
      stats: null,
      averageTimeAndon15Days: null,
      averageTimeAndon30Days: null,
      timeoutRefreshLoop: null,
      timeoutLastScan: null,
      refreshTimer: null
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.isBusy = true
    bus.currentStep = Steps[to.params.step]
    this.forceRefresh()
    next()
  },
  methods: {
    deleteThisRow: function(row, col) {
      this.lowStockGrid[row].splice(col, 1)
    },
    hideAndon(index, list, indexRow, indexCol) {
      list[indexRow][indexCol].splice(index, 1)
      this.$forceUpdate()
    },
    stopCardAndon() {
      server.stopSpecificAndon(this.selectedItem).then(() => {})
    },
    generateGrid() {
      var grid = new Array(26)
      for (var i = 0; i < grid.length; i++) {
        grid[i] = new Array(25)
      }
      return grid
    },
    getAndonFifo() {
      server.getAllAndonFifo(this.nbrAndons).then(result => {
        this.fifoGrid = this.generateGrid()
        result.data.andon_fifo.forEach(element => {
         if (!element.andon.base.stopped_at) {
            this.addAndonToGrid(element, this.fifoGrid)
          }
        })
      })
    },
    isGridListPrintable(andonList, gridName) {
      return (
        andonList &&
        andonList.length > 0 &&
        this.andonTypeSelected.includes(gridName)
      )
    },
    displayHighSeverityAndon() {
      return this.andonTypeSelected.includes('andon_high_severity')
    },
    getAndonUnseenCard() {
      server.getAllAndonUnseenCard(this.nbrAndons).then(result => {
        console.log(`Andon unseen card ${JSON.stringify(result.data)}`)
        this.unseenGrid = this.generateGrid()
        result.data.andon_unseen.forEach(element => {
          if (!element.andon.base.stopped_at) {
            this.addAndonToGrid(element, this.unseenGrid)
          }
        })
      })
    },
    addAndonToGrid(content, grid) {
      if (_.has(content, 'y') && !_.isEmpty(content.y) && _.has(content, 'x')) {
        var y = content.y.charCodeAt(0) - 65 // 'A' == 65
        if (y >= 0) {
          if (_.isEmpty(grid[y][content.x])) {
            grid[y][content.x] = new Array()
          }
          grid[y][content.x].push(content)
        }
      }
    },
    getAndonLowStock() {
      if (this.andonTypeSelected.includes('low_stock')) {
        server.getAllAndonLowStock(this.nbrAndons).then(result => {
          console.log(`Andon low stock ${JSON.stringify(result.data)}`)
          this.lowStockGrid = this.generateGrid()
          result.data.andon_low_stock.forEach(element => {
            if (!element.andon.base.stopped_at) {
              this.addAndonToGrid(element, this.lowStockGrid)
            }
          })
          this.$forceUpdate()
        })
      }
    },
    getAndonBadErpStock() {
      server.getAllAndonBadErpStock(this.nbrAndons).then(result => {
        console.log(`Andon bad erp stock ${JSON.stringify(result.data)}`)
        this.erpStockGrid = this.generateGrid()
        result.data.andon_erp_stock.forEach(element => {
        //   if (Math.abs(element.andon.erp_stock - (element.andon.kanban_reference.batch_size * element.andon.kanban_reference.nbr_card)) <
        //       (0.3 * (element.andon.kanban_reference.batch_size * element.andon.kanban_reference.nbr_card))) {
        //     return
        //   }
          if (element.andon.base.stopped_at == null) {
            this.addAndonToGrid(element, this.erpStockGrid)
          }
        })
      })
    },
    getTemporaryCard() {
      server.getTemporaryCard(this.nbrAndons).then(result => {
        this.tempGrid = this.generateGrid()
        result.data.forEach(element => {
          element.y = element.kanban_reference.reference.pos_y
          element.z = element.kanban_reference.reference.pos_z
          element.x = element.kanban_reference.reference.pos_x
          element.zone = element.kanban_reference.reference.zone
          this.addAndonToGrid(element, this.tempGrid)
        })
      })
    },
    displayStep(stepCode) {
      return Steps[stepCode].display
    },
    updateLastScan() {
      server.getLastScan(bus.currentStep.code).then(response => {
        this.lastScan = response.data.last_scan
      })
      this.setProtectedTimeout(this.updateLastScan, 30000)
    },
    saveFilterPreference (checked) {
      const parsed = JSON.stringify(checked);
      localStorage.setItem('andon_filters', parsed);
    },
    addAndonType(text, name) {
      this.andonType.push({ text, value: name })
    },
    getAndonStats() {
      if (bus.currentStep.code === 'ALL') {
        server.getStatsAllSteps().then(response => {
          this.stats = response.data.stats
        })
      } else {
        server.getStats(bus.currentStep.code).then(response => {
          this.stats = response.data.stats
        })
      }
      server.getAvgtime(15).then(response => {
        var sum = 0
        for (var obj in response.data.stats) {
          sum += response.data.stats[obj].average_in_h
        }
        this.averageTimeAndon15Days = Math.trunc(
          sum / response.data.stats.length
        )
      })
      server.getAvgtime(30).then(response => {
        var sum = 0
        for (var obj in response.data.stats) {
          sum += response.data.stats[obj].average_in_h
        }
        this.averageTimeAndon30Days = Math.trunc(
          sum / response.data.stats.length
        )
      })
    },
    changeSelectedType (checked) {
      this.saveFilterPreference(checked)
    },
    forceRefresh () {
      if (this.refreshTimer) {
        clearTimeout(this.refreshTimer)
      }
      this.refreshLoop()
    },
    refreshLoop () {
      this.getAndonFifo()
      this.getAndonUnseenCard()
      this.getAndonLowStock()
      this.getAndonBadErpStock()
      this.getTemporaryCard()
      this.getAndonStats()
      this.refreshTimer = this.setProtectedTimeout(this.refreshLoop, 60000)
    },
    refreshTable () {
      this.getAndonFifo()
      this.getAndonUnseenCard()
      this.getAndonLowStock()
      this.getAndonBadErpStock()
      this.getTemporaryCard()
      this.refreshTimer = this.setProtectedTimeout(this.refreshLoop, 60000)
    },
    loadPreferences () {
      let storageKey = 'andon_filters'
      if(localStorage.getItem(storageKey))
      {
        try {
          this.andonTypeSelected = JSON.parse(localStorage.getItem(storageKey));
        } catch(e) {
          localStorage.removeItem(storageKey);
        }
      }
      // this.addAndonType('Andons critiques', 'andon_high_severity')
    }
  },
  mounted: function() {
    if (this.$route.params.step) {
      bus.currentStep = Steps[this.$route.params.step]
    } else {
      bus.currentStep = Steps['ALL']
    }
    this.grid = this.generateGrid()
    this.lowStockGrid = this.generateGrid()
    this.unseenGrid = this.generateGrid()
    this.fifoGrid = this.generateGrid()
    this.erpStockGrid = this.generateGrid()
    this.tempGrid = this.generateGrid()

    this.addAndonType('Fifo', 'fifo')
    this.addAndonType('Peu de stock', 'low_stock')
    this.addAndonType('Carte en retard', 'unseen_card')
    this.addAndonType('Andons ERP stock', 'bad_erp_stock')
    this.addAndonType('Carte temporaire', 'temp_card')

    this.loadPreferences()
    this.refreshLoop()
    // this.updateLastScan()
  },
  destroyed() {
    clearTimeout(this.timeoutLastScan)
    clearTimeout(this.timeoutRefreshLoop)
  },
  components: { FifoCard, LowStockCard, UnseenCard, BadErpStockCard, StatsComp, TempCard }
}
</script>

  <style type="text/css">
.jumbotron {
  padding: 10px;
}
#avg_time_andon {
  font-size: 14px;
  /*text-align: right;*/
  margin-right: 50px;
}


#red_sticker {
  color: red;
  border: none;
}

.cells_infos_extra {
  font-size: 10px;
  font-family: arial;
  margin: 0px;
}
.cells_infos {
  font-size: 14px;
  font-family: arial;
  margin: 0px;
}
#andontable {
  margin-top: 50px;
}
.card-header {
  padding: 0.3rem;
}
.card-body {
  width: 170px;
  padding: 0.3rem;
  width: 100%;
}
#right-click-menu {
  background: #fafafa;
  border: 1px solid #bdbdbd;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  display: block;
  list-style: none;
  margin: 0;
  padding: 0;
  position: absolute;
  width: 250px;
  z-index: 999999;
}

#right-click-menu li {
  border-bottom: 1px solid #e0e0e0;
  margin: 0;
  padding: 5px 35px;
}

#right-click-menu li:last-child {
  border-bottom: none;
}

#right-click-menu li:hover {
  background: #1e88e5;
  color: #fafafa;
}
.grey {
  background-color: #e9ecef;
}
.input-andon-nbr {
  max-width: 200px;
}
.input-align {
  display: flex;
  align-items: center;
  justify-content: center;
}
.label-input {
  margin-bottom: 0px;;
}

</style>


// WEBPACK FOOTER //
// src/components/andon/AnalyseAndonKanban.vue